import React from 'react';
import Slider from 'react-rangeslider';
import { useTranslation } from 'react-i18next';

// To include the default styles
import 'react-rangeslider/lib/index.css';

export function DividerConfig({ obj, handleDividerSetting }) {
  const { t } = useTranslation('common');
  const { width, weight, gap } = obj?.dividerProperty || {};

  return (
    <div className="p-3">
      <div className="custom-slider w-50 mb-4">
        <p className="f-13 mb-0">{t('CUSTOM_MODULE.WIDTH')}</p>
        <Slider min={0} max={100} step={10} value={width} orientation="horizontal" reverse={false} onChange={(e) => handleDividerSetting(e, 'width')} />
      </div>
      <div className="custom-slider w-50 mb-4">
        <p className="f-13 mb-0">{t('CUSTOM_MODULE.WEIGHT')}</p>
        <Slider min={0} max={10} step={1} value={weight} orientation="horizontal" reverse={false} onChange={(e) => handleDividerSetting(e, 'weight')} />
      </div>
      <div className="custom-slider w-50 mb-4">
        <p className="f-13 mb-0">{t('CUSTOM_MODULE.GAP')}</p>
        <Slider min={0} max={20} step={2} value={gap} orientation="horizontal" reverse={false} onChange={(e) => handleDividerSetting(e, 'gap')} />
      </div>
    </div>
  );
}

export default DividerConfig;
